/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusAnforderungAufgabenResponseDto } from '../../models/lexplus-anforderung-aufgaben-response-dto';

export interface AnforderungDetailControllerGetAnforderungAufgabenV1$Params {
  anforderungsversionID: number;
  erledigtLimit?: number;
  checklistQuestionID?: number;
  standortID?: number;
}

export function anforderungDetailControllerGetAnforderungAufgabenV1(http: HttpClient, rootUrl: string, params: AnforderungDetailControllerGetAnforderungAufgabenV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusAnforderungAufgabenResponseDto>> {
  const rb = new RequestBuilder(rootUrl, anforderungDetailControllerGetAnforderungAufgabenV1.PATH, 'get');
  if (params) {
    rb.path('anforderungsversionID', params.anforderungsversionID, {});
    rb.query('erledigtLimit', params.erledigtLimit, {});
    rb.query('checklistQuestionID', params.checklistQuestionID, {});
    rb.query('standortID', params.standortID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusAnforderungAufgabenResponseDto>;
    })
  );
}

anforderungDetailControllerGetAnforderungAufgabenV1.PATH = '/v1/compliance/anforderungen/{anforderungsversionID}/aufgaben';
